import { useState } from "react";
import { Copy, Check, ExternalLink } from "lucide-react";
import { ADDRESSES, EXPLORER_TOKEN, dexSwapUrl } from "../lib/config";

/// Prominent, copyable PIGGY contract address. Traders need this to paste into
/// Uniswap's "import token" box, so it lives in the hero — not buried in a
/// panel. Shows the full address on desktop, a middle-truncated form on mobile.
export function ContractAddressBar() {
    const token = ADDRESSES.PIGGY_TOKEN;
    const [copied, setCopied] = useState(false);
    if (!token) return null;

    const short = `${token.slice(0, 6)}…${token.slice(-4)}`;
    const copy = async () => {
        try {
            await navigator.clipboard.writeText(token);
            setCopied(true);
            setTimeout(() => setCopied(false), 1600);
        } catch {
            /* clipboard blocked — the address is still visible to select */
        }
    };

    return (
        <div className="inline-flex flex-wrap items-center justify-center gap-x-2 gap-y-1.5 rounded-2xl glass-pink px-3 py-2 text-sm">
            <span className="font-semibold text-piggy-pink-200 uppercase tracking-wider text-xs px-1">
                PIGGY contract
            </span>
            <button
                type="button"
                onClick={copy}
                aria-label={copied ? "Address copied" : "Copy PIGGY contract address"}
                className="group inline-flex items-center gap-2 rounded-xl bg-black/30 px-3 py-1.5 font-mono text-piggy-cream hover:bg-black/50 transition-colors"
            >
                <span className="hidden sm:inline">{token}</span>
                <span className="sm:hidden">{short}</span>
                {copied ? (
                    <Check className="w-4 h-4 text-piggy-pink-300 flex-shrink-0" />
                ) : (
                    <Copy className="w-4 h-4 text-piggy-cream/50 group-hover:text-piggy-cream flex-shrink-0" />
                )}
            </button>
            <div className="inline-flex items-center gap-1">
                <a
                    href={`${EXPLORER_TOKEN}/${token}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1 rounded-xl px-2.5 py-1.5 text-xs text-piggy-cream/70 hover:text-piggy-cream hover:bg-white/[0.05] transition-colors"
                >
                    Blockscout <ExternalLink className="w-3 h-3" />
                </a>
                {dexSwapUrl(token) && (
                    <a
                        href={dexSwapUrl(token)!}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-1 rounded-xl px-2.5 py-1.5 text-xs text-piggy-cream/70 hover:text-piggy-cream hover:bg-white/[0.05] transition-colors"
                    >
                        Uniswap <ExternalLink className="w-3 h-3" />
                    </a>
                )}
            </div>
        </div>
    );
}
